import { useQuery } from "@tanstack/react-query";

const API = import.meta.env.VITE_API_BASE_URL;

async function fetchMetricRange({ metric, hostname, start, end, step }) {
  const params = new URLSearchParams({
    metric,
    hostname,
    start: Math.floor(start / 1000).toString(),  // ms → seconds
    end: Math.floor(end / 1000).toString(),
    ...(step ? { step: step.toString() } : {}),
  });
  const res = await fetch(`${API}metrics/range?${params}`, { credentials: "include" });
  if (!res.ok) throw new Error(`metrics/range ${res.status}`);
  return res.json();
}

// Returns { data, isLoading, isError, error }
// data is an array of { metric, hostname, sensor, points: [{t, v}] }
export function useMetricQuery({ metric, hostname, start, end, step, enabled = true }) {
  return useQuery({
    queryKey: ["metric", metric, hostname, start, end, step],
    queryFn: () => fetchMetricRange({ metric, hostname, start, end, step }),
    enabled: enabled && !!metric && !!hostname && !!start && !!end,
    staleTime: 30_000,       // treat data as fresh for 30s
    refetchInterval: 60_000, // auto-refresh every 60s
  });
}
